/* eslint-disable react/jsx-key */
/* eslint-disable react/display-name */
import { DUKE_FHO } from 'client'
import { getClientInfo } from 'core'
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

const cellStyle = {
  paddingBottom: '2px',
  paddingTop: '2px',
  // borderBottom: '1px solid #ccc',
  border: '1px solid #ccc',
  height: '18px',
  padding: '0px',
  fontSize: '0.85em',
  fontWeight: 'normal',
  paddingRight: '2px',
}

const Header = styled.div`
  border: 1px solid rgb(204, 204, 204);
  background-color: #eeeeee;
  color: black;
  text-align: center;
  height: 18px;
  font-size: 0.85em;
  font-weight: normal;
`
const PiaTableInfoAntd = ({ data, CLIENT }) => {
  const loadData = (type, cellStyle, otherLabel) => {
    const b = data.find(t => t.ITEM === type)
    if (b === undefined) return ''
    const rgb = `rgb(${b.RED},${b.GREEN},${b.BLUE},0.5)`

    return [
      <div style={cellStyle}>{otherLabel || b.ITEM}</div>,
      <div
        style={{ backgroundColor: rgb, ...cellStyle, textAlign: 'right' }}
        inverted
      >
        {b.MWH}
      </div>,
      <div
        style={{ backgroundColor: rgb, ...cellStyle, textAlign: 'right' }}
        inverted
      >
        {b.PERCENT}
      </div>,
    ]
  }

  if (data === undefined || data.length === 0) return <div />

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '3fr 2fr 1fr',
        alignContent: 'baseline',
      }}
    >
      <Header>Name</Header>
      <Header>MWH</Header>
      <Header style={{ textAlign: 'right', minWidth: '50px' }}>%</Header>
      {loadData('Forced', cellStyle)}
      {loadData('Planned', cellStyle)}
      {loadData('Maintenance', cellStyle)}
      {loadData('Extension', cellStyle)}
      {loadData('Inactive', cellStyle)}
      {loadData('Reserve', cellStyle)}
      {CLIENT === DUKE_FHO &&
        loadData('Available', cellStyle, 'Serv/Pump/Sync')}
      {CLIENT !== DUKE_FHO && loadData('Available', cellStyle)}
    </div>
  )
}

const mapStateToProps = state => ({
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(PiaTableInfoAntd)
